import { useSelector } from '@legendapp/state/react';
import { creditBalance$, fetchBalance } from '../store/billing$';

/**
 * Hook to read credit balance from the app-level billing$ singleton.
 * All polling logic lives in billing$.js — this hook is a thin reactive reader
 * with zero side effects.
 */
export function useCreditBalance() {
  const balance = useSelector(() => creditBalance$.balance.get());
  const tierCredits = useSelector(() => creditBalance$.tierCredits.get());
  const permanentCredits = useSelector(() => creditBalance$.permanentCredits.get());
  const loading = useSelector(() => creditBalance$.loading.get());
  const error = useSelector(() => creditBalance$.error.get());
  return { balance, tierCredits, permanentCredits, loading, error, refresh: fetchBalance };
}

// Legacy export for backward compatibility
export const useTokenBalance = useCreditBalance;
